import React from "react";
import { NavLink } from "react-router-dom";
import { Button, Result, Space, Typography } from "antd";

const { Paragraph } = Typography;

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Result
      status="500"
      title="خطا"
      subTitle={
        <Paragraph style={{ color: "inherit" }}>{error.message}</Paragraph>
      }
      extra={
        <Space size={8}>
          <Button
            shape="round"
            type="primary"
            className="pr-20 pl-20"
            onClick={resetErrorBoundary}
          >
            بازگشت
          </Button>

          <NavLink
            component={HomeBtn}
            className="pr-20 pl-20 ant-btn-secondary"
            to={`/home`}
          >
            خانه
          </NavLink>
        </Space>
      }
    />
  );
}

function HomeBtn(props) {
  return (
    <Button shape="round" {...props}>
      {props.children}
    </Button>
  );
}

export default ErrorFallback;
